import { useEffect } from 'react';
import { useGeolocation } from 'react-use';
import { useMutation } from 'react-relay';

import { UserGeoLocationAdd } from './UserGeoLocationAddMutation';
import type { UserGeoLocationAddMutation } from './__generated__/UserGeoLocationAddMutation.graphql';

export const useGeolocationUserLocationAdd = () => {
  const [userGeolocationAdd] =
    useMutation<UserGeoLocationAddMutation>(UserGeoLocationAdd);

  const geolocation = useGeolocation();

  const saveGeolocation = (geolocation) => {
    const { latitude, longitude, timestamp } = geolocation;

    const points = [
      {
        latitude,
        longitude,
        source: 'WEB',
        timestamp: new Date(timestamp).toISOString(),
      },
    ];

    const input = {
      points,
    };

    const config = {
      variables: {
        input,
      },
    };

    userGeolocationAdd(config);
  };

  useEffect(() => {
    if (!geolocation.loading && geolocation.latitude) {
      saveGeolocation(geolocation);
    }
  }, [geolocation.latitude]);
};
